import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

const humanize = (s) => s.replace(/_/g," ").replace(/\b\w/g, c => c.toUpperCase());

export default function TabBack({ project, onChange }) {
  const [bm, setBm] = useState(project.backmatter);
  const [presets, setPresets] = useState(project.presets);
  const [busy, setBusy] = useState(false);
  const order = [
    ["worksheet_cta","Companion Resource / Worksheet CTA"],
    ["recommended_next_reads","Recommended Next Reads"],
    ["review_request","Review Request / Share This Guide"],
    ["about_author","About the Author"],
    ["about_ph360","About PublishingHub360"],
    ["closing_note","Publisher's Closing Note"],
  ];
  const presetKeys = ["worksheet_cta","recommended_next_reads","review_request","about_ph360","closing_note"];
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ph360/settings/back", { backmatter: bm, presets });
      onChange(data);
      toast.success("Back matter saved");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <>
      <h2>Back Matter</h2>
      {order.map(([k, label]) => (
        <label className="checkbox-line" key={k}>
          <input type="checkbox" checked={!!bm[k]} onChange={(e)=>setBm({...bm,[k]:e.target.checked})} data-testid={`back-toggle-${k}`}/>
          {label}
        </label>
      ))}
      <p className="description"><strong>Publishing order:</strong> Companion Resource → Recommended Next Reads → Share This Guide → About the Author → About PublishingHub360 → Publisher's Closing Note.</p>
      {presetKeys.map(k => (
        <div key={k} style={{marginBottom:8}}>
          <label>{humanize(k)}</label>
          <textarea rows={5} value={presets[k]||""} onChange={(e)=>setPresets({...presets,[k]:e.target.value})} data-testid={`back-preset-${k}`}/>
        </div>
      ))}
      <p style={{marginTop:14}}>
        <button className="button button-primary" onClick={save} disabled={busy} data-testid="back-save">
          {busy ? "Saving…" : "Save Back Matter"}
        </button>
      </p>
    </>
  );
}
